module.exports = "/images/vendor/flag-icon-css/flags/4x3/ru.svg?0cacf46e6f473fa88781120f370d6107";